import odata from "@/core/api/mixin/odata";
import rest from "@/core/api/mixin/rest";
import { apiClient } from "@/core/api/httpClient";

export default {
  ...odata("campaigns"),
  ...rest("campaigns"),

  getStatistic: function (id, payload) {
    return apiClient.get(`campaigns/${id}/rules-statistic`);
  },

  loadStatusSummaryReport: async (compId, type) => {
    return await apiClient.get(`campaigns/${compId}/rules-summary/${type}`);
  },
};
